import {
  PropertyLocaltion,
  IconEye,
  HomeGray,
  CalendarGray,
  ArrowRightCMS,
  HeroImagePlaceholder,
} from 'common/components/svgs';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import formatPrice from '~helpers/currency';
import { imageUrl } from '~helpers/gallery';
import { imageSizes } from '~constants/gallery';
import { Hosts } from '~helpers/environments';
import { formatTenancyLength } from 'common/helpers/formatTenancyLength';

const useStyles = makeStyles(theme => ({
  box: {
    border: '1px solid #D9D9D9',
    backgroundColor: '#FFFFFF',
    borderRadius: '2px',
    paddingRight: '32px',
    display: 'flex',
    '& > .img': {
      width: '182px',
      height: '112px',
      marginRight: '24px',
    },
    '& > .heroImagePlaceholder': {
      width: '182px',
      height: '112px',
      marginRight: '24px',
    },
  },
  infoLine: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    '& > .name': {
      ...theme.typography.body2,
    },
  },
  infoPrice: {
    marginLeft: 'auto',
    ...theme.typography.body2,
  },
  infoBox: {
    backgroundColor: '#FAFAFA',
    borderRadius: '2px',
    padding: '17px 32px 17px 20px',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '12px',
  },
  h4: {
    ...theme.typography.h4,
  },
  nameWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  location: {
    display: 'flex',
    alignItems: 'center',
    ...theme.typography.body2,
    gap: '8px',
  },
  eyelink: {
    display: 'flex',
    marginLeft: 'auto',
    alignItems: 'center',
    cursor: 'pointer',
    gap: '8px',
    ...theme.typography.body4,
    color: '#38B2A6',
  },
}));

const generatePropertyUrl = property => {
  const path = `${
    property.city && property.city.country && property.city.country.slug
      ? property.city.country.slug
      : ''
  }/${property.city && property.city.slug ? property.city.slug : ''}/p/${property.slug}`;

  return `${Hosts.propertyUrl}${path}`;
};
function ProductInfo({ bookingData, property }) {
  const classes = useStyles();
  const { t } = useTranslation('landlord');
  const heroImageUrl = imageUrl(property?.heroImage, imageSizes.smallHeroImageThumbnail);
  return (
    <div>
      <div className={classes.box}>
        {heroImageUrl ? (
          <img className="img" src={heroImageUrl} alt="" />
        ) : (
          <div className="heroImagePlaceholder">
            <HeroImagePlaceholder />
          </div>
        )}
        <div className={classes.nameWrapper}>
          <div className={classes.h4}>{property?.name}</div>
          <div className={classes.location}>
            <PropertyLocaltion />
            <div>
              {property?.city?.name}, {property?.city?.country?.name}
            </div>
          </div>
        </div>
        <div
          className={classes.eyelink}
          onClick={() => {
            window.open(generatePropertyUrl(property), '_blank');
          }}
        >
          <IconEye />
          <div>View Property on Student.com</div>
        </div>
      </div>
      <div className={classes.infoBox}>
        <div className={classes.infoLine}>
          <HomeGray />
          <div className="name">{bookingData?.unitTypeName}</div>
          <div className="name" style={{ color: 'rgba(0, 0, 0, 0.45)' }}>
            (
            {t(
              `landlord.long_tail.booking.unit_type_category.${bookingData?.unitTypeCategory.toLowerCase()}`,
            )}
            )
          </div>
        </div>
        <div className={classes.infoLine} style={{ marginTop: '8px' }}>
          <div className={classes.infoLine}>
            <CalendarGray />
            <div className="name">{moment(bookingData.moveInDate).format('DD/MM/YYYY')}</div>
            <ArrowRightCMS />
            <div className="name">{moment(bookingData.moveOutDate).format('DD/MM/YYYY')}</div>

            <Divider type="vertical" />
            <div className="name">
              {formatTenancyLength(
                bookingData?.tenancyLength?.weeks,
                bookingData?.tenancyLength?.days,
              )}
            </div>
          </div>
          <div className={classes.infoPrice}>
            Total Price:{' '}
            <span style={{ fontWeight: 600 }}>
              {formatPrice(bookingData.totalPrice, bookingData.currency)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductInfo;
